import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/lightcharter/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/lightcharter/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/lightcharter/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/lightcharter/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/lightcharter/${Id}`);
  },
};
